/**
 * Admin utilities for checking user permissions
 */

// VITE_ADMIN_EMAILS=comma,separated,emails overrides DEFAULT_ADMINS.
const ADMIN_EMAILS = import.meta.env.VITE_ADMIN_EMAILS?.split(',').map((email: string) => email.trim()) || [];

const DEFAULT_ADMINS = ['bshannon@gmail.com'];

/**
 * Check if a user email is an admin
 * @param email - User's email address
 * @returns boolean indicating admin status
 */
export const isAdminEmail = (email: string | undefined): boolean => {
  if (!email) return false;

  const normalizedEmail = email.toLowerCase().trim();

  if (ADMIN_EMAILS.length > 0) {
    return ADMIN_EMAILS.some((adminEmail: string) =>
      adminEmail.toLowerCase() === normalizedEmail
    );
  }

  return DEFAULT_ADMINS.some((adminEmail: string) =>
    adminEmail.toLowerCase() === normalizedEmail
  );
};

/**
 * Check if the current user is an admin
 * @param user - User object from auth context
 * @returns boolean indicating admin status
 */
export const isAdmin = (user: { email?: string; isAdmin?: boolean } | null): boolean => {
  if (!user) return false;
  if (user.isAdmin === true) return true;
  return isAdminEmail(user.email);
};

import { useAuth } from '../contexts/AuthProvider';

export const useIsAdmin = (): boolean => {
  const { user } = useAuth();
  return isAdmin(user);
};